import { Spinner } from '@hopin-team/ui-spinner';
import { rem } from 'polished';
import styled from 'styled-components';

const LoadingContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${rem(16)};
`;

export const BrandedSpinner = styled(Spinner)`
  border-color: ${({ theme }) =>
    `${theme.COLOR.PRIMARY?.['400']} ${theme.COLOR.PRIMARY?.['100']} ${theme.COLOR.PRIMARY?.['100']}`};
`;

export { LoadingContainer };
